<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  // import LayoutVue from './components/Layout.vue'
  import axios from '@/utils/request';
  export default {
    name: 'Layout',
    // components: {
    //   LayoutVue
    // },
    created(){
      // if(localStorage.getItem('token')){
      //   this.getData()
      // }
    },
    methods:{
      getData(){
        axios.get('/user_info')
            .then(res => {
                if(res.code == 0){
                  this.$store.commit('setGlobalVar', res.data)
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
      }
    }
  }
</script>

<style>
body,html{
  background: #f2f2f2;
  height:100%
}
#app{
  height:100%
}
.el-menu{
  border-right:none !important;
}
*{
  margin: 0;
  padding: 0;
}
.page{
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}
.home{
  height:100%;
  background: #fff;
  border-radius: 5px;
  display:flex;
  flex-direction:column
}
.mian{
  flex:1;
}
.step_one .el-form-item__content{
  max-width: 600px;
}
.step_one .el-input--mini .el-input__inner{
  height: 40px !important;
  line-height: 40px !important;
  font-size: 14px;
}
.el-dialog{
  max-width: 700px;
}
.chose_stpres .el-dialog{
  max-width: 1000px !important;
}
.el-table th.el-table__cell>.cell{
  font-weight: normal !important;
}
.el-tabs__content{
  display: none !important;
}
.else_inputs .el-input-group__prepend{
  width:73px !important;
}
/* .ediotr img{
    height: 200px !important;
} */
.goods_main_boes_box .el-checkbox__label{
    display:none !important;
}
.chose_goods_box .el-dialog{
  max-width: 1200px !important;
}
.chose_goods_mains .el-dialog{
  max-width: 100% !important;
}
.merchart_header{
    background: #fff;
    padding:15px 15px 0 15px;
    border-radius: 5px;
}
.mian_header{
   margin-bottom:10px
}
.mian{
    background: #fff;
    padding:0 15px;
    border-radius: 5px;
}
.exports_mains .el-dialog{
    max-width: 500px !important;
}
.chose_areas .el-dialog{
    width: 1000px !important;
    max-width: 1000px !important;
}
.el-loading-mask {
  z-index: 999999 !important; /* 或者更高的值 */
}
.main__phone_item .el-input__inner{
  border: none !important;
  padding: 0 !important;
}
.file_box .el-upload{
    width: 100% !important;
    height: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.el-image-viewer__canvas{
  height: 70% !important;
  margin-top: 8%;
}
.step_end .el-form-item__content{
  width: 300px;
}
.step_end .el-textarea__inner{
  height: 100px;
}
.el-table__row--level-1{
  background: #f6f6f6 !important;
}
.files_box .el-upload{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.highlight-row{
    background: #fafafa !important;
}
.list_form .el-form-item{
  margin-bottom: 5px !important;
}
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none;
  margin: 0;
}
.left .el-cascader-menu__wrap{
  height: 100%;
}
.left .el-cascader-menu{
  width: 33%;
}
.after_detail .el-descriptions__body{
  background: none !important;
}
.msg_content .el-table .cell{
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.msg_user_group .el-checkbox{
  margin: 5px 0 !important;
}
.step_redixs .is-true i{
  color: #409eff !important;
}
.step_redixs .is-true{
  color: #409eff !important;
}
.el-menu-item:hover a{
  color: #2589FF !important;
}
.el-table{
  font-size: 12px !important;
}
/* 筛选1行的样式 开始 */
.sxBtn{
  background-color: #ecf5ff;
    border-color: #d9ecff;
    height: 32px;
    padding: 0 10px;
    line-height: 30px;
    font-size: 12px;
    color: #409EFF;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    margin-right: 10px;
    height: 34px;
    display: inline-table;
}
.sxBtn:hover{
  cursor: pointer;
  background: #409eff;
  color: #fff;
}
.filterCon_More{
    display: inline-table;
}
/* 筛选1行的样式 结束 */
</style>
